import { useEffect } from 'react';

function useScrollTo(listRef, scrollTo: number) {
  useEffect(() => {
    if (scrollTo >= 0) {
      listRef.current.scrollLeft =
        listRef.current.children[0].offsetWidth * scrollTo;
    }
  }, [listRef, scrollTo]);
}

export default useScrollTo;
